/** PostHog send-boundary URL-login scrub, isolated to keep its policy directly testable. */

import { scrubUrlCredentialsDeep } from '#~/logger/url-credentials.js';
import type { PostHogBeforeSendEvent } from './envelope-enrichment.js';
import { POSTHOG_INTERNAL_EVENT_NAMES } from './event-names.js';

/**
 * Mask URL logins in an outgoing event's properties: relayed encoder errors,
 * $exception captures and tracked error messages can all echo a camera's
 * `rtsp://user:pass@host`. Replay snapshots are transport internals with
 * masked inputs, and too large to walk on every send.
 *
 * @param event - The event posthog-js is about to send.
 * @returns The same event when nothing changed, otherwise a scrubbed copy.
 */
export function scrubPostHogEventCredentials(
  event: PostHogBeforeSendEvent
): PostHogBeforeSendEvent {
  if (!event?.properties || event.event === POSTHOG_INTERNAL_EVENT_NAMES.SNAPSHOT) {
    return event;
  }
  const properties = scrubUrlCredentialsDeep(event.properties);
  return properties === event.properties ? event : { ...event, properties };
}
